define(
    "diy/undo-redo/RemoteRequest",
    [
        'jquery',
        'diy/util/helper'
    ],
    /**
     *
     * @param {jQuery} $
     * @param {diy.util.Helper} helper
     * @returns {*}
     */
    function ($, helper) {
        'use strict';
        var
            HISTORY_URL = '/app/cms/undoredo/get-history',
            DELETE_REDO_CHAIN_URL = '/app/cms/undoredo/delete-redo-chain',
            EXECUTE_URL = '/app/cms/undoredo/execute',
            LOG_PRIVATE_MODE_URL = '/app/cms/undoredo/log-private-mode',
            RemoteRequest;
        /**
         * @class module.undoRedo.RemoteRequest
         * @template module.undoRedo.RemoteRequest
         * @lends {module.undoRedo.RemoteRequest.prototype}
         * @constructor
         */
        RemoteRequest = Klazz.extend({
            /**
             *
             * @returns {Promise|Q.promise}
             */
            loadHistory: function loadHistory() {
                var deferred = Q.defer();
                $.ajax({
                    url: HISTORY_URL,
                    data: {},
                    dataType: 'json',
                    success: function (response) {
                        if (response && response.data && response.data.undoList) {
                            deferred.resolve(response.data);
                        } else {
                            deferred.reject(response);
                        }
                    },
                    error: function (response) {
                        deferred.reject(response);
                    }
                });
                return deferred.promise;
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            deleteRedoChain: function deleteRedoChain(){
                var deferred = Q.defer();
                $.ajax({
                    url: DELETE_REDO_CHAIN_URL,
                    data: {},
                    dataType: 'json',
                    success: function (response) {
                        deferred.resolve(response);
                    },
                    error: function (response) {
                        deferred.reject(response);
                    }
                });

                return deferred.promise;
            },
            executeRemote: function executeRemote (entryId) {
                var deferred = Q.defer();

                $.ajax({
                    url: EXECUTE_URL,
                    data: {
                        entryId: entryId,
                        context: {
                            pageId: helper.getCurrentPageId()
                        }
                    },
                    dataType: 'json',
                    type:'POST',

                    success: function(response) {
                        if (response && response.data && $.isArray(response.data)) {
                            deferred.resolve(response);
                        } else {
                            deferred.reject({message:'invalid server response', data: response});
                        }
                    },
                    error: function(response) {
                        deferred.reject({message:'server error', data: response});
                    }
                });
                return deferred.promise;
            },
            logPrivateMode: function logPrivateMode() {
                $.ajax({
                    url: LOG_PRIVATE_MODE_URL,
                    type:'POST'
                });
            }
        });

        return RemoteRequest;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/RemoteRequest.js
 ** module id = 920
 ** module chunks = 0
 **/